import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {AuthGuard} from "../../common/services/authorization/authGuard";
import {ActionsComponent} from "./actions.component";
import {ActionsListComponent} from "./actions-list/actions-list.component";
import {BuildingActionsBoardComponent} from "./building-actions-board/building-actions-board.component";
import {ActionAssignBoardComponent} from "./assign-board/action-assign-board.component";
import {TeamOverviewComponent} from "./team-overview/team-overview.component";

const routes: Routes = [
  {
    'path': '',
    pathMatch: 'full',
    redirectTo: 'jobs/list'
  },
  {
    path: 'jobs',
    component: ActionsComponent,
    canActivate: [AuthGuard], // @Todo restore permissions guard
    children: [
      // {path: '', redirectTo: 'list'},
      {
        path: 'list', component: ActionsListComponent,
        children: [{path: ':buildingId', component: BuildingActionsBoardComponent}]
      },
      {
        path: 'interventions', component: ActionAssignBoardComponent,
        //       canActivate: [PermissionsGuard],
        //       data: { permissions: [Permission.INTERVENTIONS]}
      },
      {
        path: 'team-overview', component: TeamOverviewComponent,
        //       canActivate: [PermissionsGuard],
        //       data: { permissions: [Permission.INTERVENTIONS] },
      },
    ],
  },
  // { path: 'add', component: ActionsAddComponent },
  // { path: ':actionId/details', component: ActionsDetailsModalComponent },
  // { path: ':actionId/edit', component: ActionsEditComponent },
  // { path: 'add/:issueGuid', component: ActionsAddComponent },
  // { path: ':actionId', redirectTo: '' },
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule]
})
export class ActionsRoutingModule {
}
